// @flow
import * as React from 'react'
import isRetina from 'util/is_retina'
import { applyImageProcessing, uuidToUrl } from 'util/uploadcare'

import './UploadcareImg.module.scss'

type Dimensions = {
  height: number,
  width: number,
}

type ScaleCrop = Dimensions

type Props = {
  uuid: string,
  scaleCrop?: ScaleCrop,
}

export default function Image(props: Props) {
  return <img styleName="image" src={imageUrl(props)} />
}

function imageUrl(props: Props) {
  const base = uuidToUrl(props.uuid)

  const operations = [{ format: 'auto' }, resolveScaleCropOperation(props.scaleCrop)].filter(
    Boolean,
  )

  return applyImageProcessing(base, operations)
}

function resolveScaleCropOperation(scaleCrop: ScaleCrop | void) {
  if (!scaleCrop) return null

  const { height, width } = resolveDimensions(scaleCrop)

  return { scaleCrop: `${width}x${height}` }
}

function resolveDimensions({ height, width }: Dimensions) {
  const multiplier = isRetina() ? 2 : 1

  return { height: height * multiplier, width: width * multiplier }
}
